export default __webpack_public_path__ + "f045cd1cb16982d4550144c1104c5417.png";